import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const AttributeQuery = gql`
  query attribute($id: String!) {
    attribute(id: $id) {
      id
      title
      type
      definition
      name
      slug
      priority
      isVisual
      tags
      isFilterable
      values {
        id
        title
        value
        colorHex
        slug
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  id: string;
}

interface IResponse {
  data: any;
}

class GetAttributeQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const { attribute }: any = this.props;
    return this.props.children({ attribute });
  }
}

export default compose(
  graphql<IInputProps, Response>(AttributeQuery, {
    name: 'attribute'
  })
)(GetAttributeQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Attributes/Attribute.tsx